import React from 'react';

const TONES = {
  pending: { fg: '#B6791A', bg: '#F7EBD3' },
  sent: { fg: '#2C8059', bg: '#E2F0E7' },
  info: { fg: '#3F6FB0', bg: '#E6EDF6' },
  neutral: { fg: '#6C766F', bg: 'rgba(28,40,33,0.06)' },
  accent: { fg: '#DD9F3C', bg: '#F8ECD3' },
  rose: { fg: '#B5546B', bg: '#F6E6EA' },
};

function PlatformBadge({ tone = 'pending', children, dot = false }) {
  const { fg, bg } = TONES[tone] || TONES.neutral;

  return (
    <span
      className="platform-badge"
      style={{ background: bg, color: fg }}
    >
      {dot && <span className="platform-badge-dot" style={{ background: fg }} />}
      {children}
    </span>
  );
}

export default PlatformBadge;
